// extracted by mini-css-extract-plugin
module.exports = {"wrap":"DropdownFiltersBO_wrap__29l6J","filter":"DropdownFiltersBO_filter__VCgpq","label":"DropdownFiltersBO_label__1UFfM"};